(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
    	var roles = ['Administrators', 'DAC Content Administrator', 'DAC Content User'];
        $stateProvider
        .state('dac-content-main.nasrac-source-type', {
            //parent: 'dac-content-main',
            url: '/nasrac-source-type',
            templateUrl: 'app/dac-content/nasrac-source-type/nasrac-source-types.html',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.nasracSourceType.home.title'
            },
            controller: 'NasracSourceTypeController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nasracSourceType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dac-content-main.nasrac-source-type.new', {
            parent: 'dac-content-main.nasrac-source-type',
            url: '/new',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-source-type/nasrac-source-type-dialog.html',
                    controller: 'NasracSourceTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                sourceTypeId: null,
                                sourceType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-source-type', null, { reload: 'dac-content-main.nasrac-source-type' });
                }, function() {
                    $state.go('dac-content-main.nasrac-source-type');
                });
            }]
        })
        .state('dac-content-main.nasrac-source-type.edit', {
            parent: 'dac-content-main.nasrac-source-type',
            url: '/{id}/edit',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-source-type/nasrac-source-type-dialog.html',
                    controller: 'NasracSourceTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NasracSourceType', function(NasracSourceType) {
                            return NasracSourceType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-source-type', null, { reload: 'dac-content-main.nasrac-source-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dac-content-main.nasrac-source-type.delete', {
            parent: 'dac-content-main.nasrac-source-type',
            url: '/{id}/delete',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-source-type/nasrac-source-type-delete-dialog.html',
                    controller: 'NasracSourceTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['NasracSourceType', function(NasracSourceType) {
                            return NasracSourceType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-source-type', null, { reload: 'dac-content-main.nasrac-source-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
